const getHoveredElement = (rootState) => rootState.ws.view.hoveredElement;

export default getHoveredElement;
